module.exports = __webpack_public_path__ + "img/with_incomes_expenses_eng.a6f54922.png";